export default "__VITE_ASSET__B2FC24jt__"